module.exports = "/packs/images/social/default-2849ee59326bf55eb640a0f94e2eeb99.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/social/default.jpg
// module id = 1809
// module chunks = 0